module.exports = __webpack_public_path__ + "static/media/internship.0d09763d.png";